import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import {
  PlusCircle,
  Eye,
  BarChart,
  LineChart, // LineChart not currently used, but kept from original
  PieChart,
  Table,
  LayoutDashboard,
  Info,
  ThumbsUp,
  MessageSquare,
  Share2,
  Heart,
  MessageCircle,
  Bookmark,
  Link, // Link not currently used, but kept from original
  Users, // Users not currently used, but kept from original
  Globe,
  X,
  Calendar,

    Facebook,
    Instagram,
    Linkedin,
    Twitter,
    Send
} from "lucide-react";
import { Plus} from "lucide-react";

import { useNavigate } from "react-router-dom";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  Cell,
  Pie,
  ResponsiveContainer,
  ComposedChart,
  PieChart as RePieChart,
} from "recharts";
import ChatBot from "../../components/AIChatBot/ChatBot";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl, assetsUrl } from "../../config/Config";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import img1 from "../../assets/images/ganeshji.jpg";
import PostCard from "../../components/PostCard";

ModuleRegistry.registerModules([ClientSideRowModelModule]);
const analyticsData = {
  Facebook: { likes: 850, comments: 200, shares: 100, reach: 1500 },
  Instagram: { likes: 1500, comments: 300, shares: 200, reach: 1800 },
  LinkedIn: { likes: 600, comments: 150, shares: 80, reach: 800 },
  Twitter: { likes: 900, comments: 250, shares: 120, reach: 1100 },
};

// Updated mockPosts Data to include more detailed metrics and Twitter
const mockPostsData = [
  {
    id: "post-1",
    postName: "Summer Campaign",
    platform: "Facebook", // Default platform for general table view
    date: "2023-07-10", // This date is crucial for filtering posts
    analysis: {
      metrics: [
        {
          platform: "Facebook",
          impressions: 15000,
          reach: 12000,
          likes: 850,
          shares: 120,
          comments: 90,
          views: { total: 14500, malePercent: 54, femalePercent: 46 },
          netFollows: 50,
          interactions: {
            reactions: 850,
            comments: 90,
            shares: 120,
            saves: 30,
          },
          linkClicks: 250,
          demographics: [
            { group: "18-24", male: 2000, female: 2500, total: 4500 },
            { group: "25-34", male: 3000, female: 3200, total: 6200 },
            { group: "35-44", male: 1500, female: 1800, total: 3300 },
            { group: "45-54", male: 1000, female: 1200, total: 2200 },
          ],
          topCountries: ["India", "USA", "UK"],
        },
        {
          platform: "Instagram",
          impressions: 22000,
          reach: 18000,
          likes: 1500,
          shares: 200,
          comments: 150,
          views: { total: 20000, malePercent: 48, femalePercent: 52 },
          netFollows: 150,
          interactions: {
            reactions: 1500,
            comments: 150,
            shares: 200,
            saves: 80,
          },
          linkClicks: 400,
          demographics: [
            { group: "18-24", male: 4000, female: 5000, total: 9000 },
            { group: "25-34", male: 5000, female: 4500, total: 9500 },
            { group: "35-44", male: 2000, female: 1500, total: 3500 },
          ],
          topCountries: ["USA", "Brazil", "Germany"],
        },
        {
          platform: "LinkedIn",
          impressions: 10000,
          reach: 8000,
          likes: 600,
          shares: 100,
          comments: 80,
          views: { total: 9000, malePercent: 60, femalePercent: 40 },
          netFollows: 80,
          interactions: {
            reactions: 600,
            comments: 80,
            shares: 100,
            saves: 20,
          },
          linkClicks: 150,
          demographics: [
            { group: "25-34", male: 2500, female: 2000, total: 4500 },
            { group: "35-44", male: 2000, female: 1500, total: 3500 },
            { group: "45-54", male: 1000, female: 500, total: 1500 },
          ],
          topCountries: ["Canada", "France", "Australia"],
        },
        {
          platform: "Twitter",
          impressions: 18000,
          reach: 15000,
          likes: 900,
          shares: 250,
          comments: 110,
          views: { total: 17000, malePercent: 50, femalePercent: 50 },
          netFollows: 120,
          interactions: {
            reactions: 900,
            comments: 110,
            shares: 250,
            saves: 10,
          },
          linkClicks: 300,
          demographics: [
            { group: "18-24", male: 3000, female: 3500, total: 6500 },
            { group: "25-34", male: 4000, female: 3000, total: 7000 },
            { group: "35-44", male: 2000, female: 1000, total: 3000 },
          ],
          topCountries: ["USA", "UK", "Japan"],
        },
      ],
      aiSummary: [
        "Instagram performed better in engagement.",
        "Facebook had good reach but fewer likes.",
        "LinkedIn showed professional engagement.",
        "Twitter showed good virality with high shares.",
      ],
      aiRecommendations: [
        "Use Instagram Reels more.",
        "Improve CTA on Facebook.",
        "Post career insights on LinkedIn.",
        "Optimize Twitter hashtags for trending topics.",
        "Best post time: 10 AM - 2 PM.",
        "Use trending summer hashtags.",
      ],
    },
  },
  {
    id: "post-2",
    postName: "New Product Launch",
    platform: "Instagram", // Default platform for general table view
    date: "2023-07-05", // This date is crucial for filtering posts
    analysis: {
      metrics: [
        {
          platform: "Instagram",
          impressions: 30000,
          reach: 25000,
          likes: 2500,
          shares: 300,
          comments: 200,
          views: { total: 28000, malePercent: 50, femalePercent: 50 },
          netFollows: 200,
          interactions: {
            reactions: 2500,
            comments: 200,
            shares: 300,
            saves: 100,
          },
          linkClicks: 500,
          demographics: [
            { group: "18-24", male: 6000, female: 7000, total: 13000 },
            { group: "25-34", male: 7000, female: 6000, total: 13000 },
            { group: "35-44", male: 3000, female: 2000, total: 5000 },
          ],
          topCountries: ["India", "USA", "Indonesia"],
        },
        {
          platform: "Facebook",
          impressions: 18000,
          reach: 15000,
          likes: 1000,
          shares: 150,
          comments: 100,
          views: { total: 16000, malePercent: 55, femalePercent: 45 },
          netFollows: 60,
          interactions: {
            reactions: 1000,
            comments: 100,
            shares: 150,
            saves: 40,
          },
          linkClicks: 300,
          demographics: [
            { group: "25-34", male: 4000, female: 3500, total: 7500 },
            { group: "35-44", male: 3000, female: 2500, total: 5500 },
            { group: "45-54", male: 1500, female: 1000, total: 2500 },
          ],
          topCountries: ["USA", "UK", "Canada"],
        },
        {
          platform: "LinkedIn",
          impressions: 12000,
          reach: 10000,
          likes: 750,
          saves: 50,
          shares: 180,
          comments: 110,
          views: { total: 11000, malePercent: 65, femalePercent: 35 },
          netFollows: 100,
          interactions: {
            reactions: 750,
            comments: 110,
            shares: 180,
            saves: 50,
          },
          linkClicks: 200,
          demographics: [
            { group: "35-44", male: 3000, female: 2500, total: 5500 },
            { group: "45-54", male: 2500, female: 1500, total: 4000 },
            { group: "55+", male: 1000, female: 500, total: 1500 },
          ],
          topCountries: ["Germany", "Japan", "Brazil"],
        },
        {
          platform: "Twitter",
          impressions: 25000,
          reach: 20000,
          likes: 1800,
          shares: 400,
          comments: 180,
          views: { total: 22000, malePercent: 45, femalePercent: 55 },
          netFollows: 180,
          interactions: {
            reactions: 1800,
            comments: 180,
            shares: 400,
            saves: 20,
          },
          linkClicks: 600,
          demographics: [
            { group: "18-24", male: 5000, female: 6000, total: 11000 },
            { group: "25-34", male: 6000, female: 5000, total: 11000 },
            { group: "35-44", male: 2000, female: 1500, total: 3500 },
          ],
          topCountries: ["USA", "India", "UK"],
        },
      ],
      aiSummary: [
        "Instagram had high engagement.",
        "Facebook was decent but lower.",
        "LinkedIn brought quality leads.",
        "Twitter generated significant reach and shares for product launch.",
      ],
      aiRecommendations: [
        "Use Reels and Stories.",
        "Promote cross-platform.",
        "Use polls or quizzes.",
        "Target LinkedIn professionals with value content.",
        "Leverage Twitter trends and influencers for future launches.",
      ],
    },
  },
];

const COLORS = ["#1877F2", "#E1306C", "#0A66C2", "#1DA1F2"];
const PostDetails = () => {
  const [selectedPost, setSelectedPost] = useState(null);
  const [showDetailedPlatformModal, setShowDetailedPlatformModal] =
    useState(false);
  const [currentPlatformData, setCurrentPlatformData] = useState(null);
  const [chartType, setChartType] = useState("bar");
  const navigate = useNavigate();
  // Date range state for the analysis popup
  const [analysisFilterRange, setAnalysisFilterRange] = useState("all"); // 'all' initially, or '15'
  const [analysisCustomDateRange, setAnalysisCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [viewMode, setViewMode] = useState("table"); // 'table' | 'chart' 'demographics' 'ai'
  const [selectedMetric, setSelectedMetric] = useState("likes");

  const userdata = useSelector((store) => store.userReducer.userdata);
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState();
  const [showLoading, setShowLoading] = useState(false);

  const [liveFBDataMap, setLiveFBDataMap] = useState({});
  const [liveChartMetrics, setLiveChartMetrics] = useState([]);
  const dispatch = useDispatch();

  const [platformkeyobj, setplatformkeyobj] = useState({});
  const platformkeyobjRef = useRef(null);
  platformkeyobjRef.current = platformkeyobj;

  const [allpostlist, setallpostlist] = useState([]);

  const filteredAnalysisDataForSelectedPost = useMemo(() => {
    if (!selectedPost) return null;

    const postDate = new Date(selectedPost?.date);
    const today = new Date();

    if (analysisFilterRange === "all") {
      return selectedPost; // Show all data for the selected post
    } else if (analysisFilterRange === "custom") {
      const from = new Date(analysisCustomDateRange.from);
      const to = new Date(analysisCustomDateRange.to);
      if (postDate >= from && postDate <= to) {
        return selectedPost;
      } else {
        return null; // Post date is outside the custom range
      }
    } else {
      // Last X days logic
      const days = parseInt(analysisFilterRange);
      const from = new Date();
      from.setDate(today.getDate() - days);
      if (postDate >= from) {
        return selectedPost;
      } else {
        return null; // Post date is outside the relative range
      }
    }
  }, [selectedPost, analysisFilterRange, analysisCustomDateRange]);

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Post Name",
        field: "postName",
        flex: 1,
        cellClass: "inventory-cell",
      },
      {
        headerName: "Platform",
        field: "platform",
        flex: 1,
        cellClass: "inventory-cell",
      },
      {
        headerName: "Date",
        field: "date",
        flex: 1,
        cellClass: "inventory-cell",
      },
      {
        headerName: "Analysis",
        field: "action",
        cellRenderer: (params) => (
          <button
            className="post-details-view-btn"
            onClick={() => {
              setSelectedPost(params.data);
              setShowDetailedPlatformModal(false);
              setCurrentPlatformData(null);
              setViewMode("table"); // Default to chart view when analysis is clicked
              // Reset analysis date filter when opening a new post's analysis
              setAnalysisFilterRange("all");
              setAnalysisCustomDateRange({ from: "", to: "" });
            }}
          >
            <Eye size={16} />
          </button>
        ),
        width: 120,
      },
    ],
    []
  );

  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      sortable: true,
      filter: true,
      flex: 1,
    }),
    []
  );

  // Define platforms and their corresponding colors for the bar chart
  const platformColors = useMemo(() => {
    return {
      "Facebook - NewBlog": "#1DA1F2", // ✅ Add if exists
      "Instagram - InstaPage1": "#E1306C",
      "Instagram - InstaPage2": "#C13584",
      "LinkedIn - MyCompany": "#0077B5",
      "Twitter - Handle1": "#1DA1F2",
      default: "#ee806cff",
    };
  }, []);
  const platformOrder = ["Facebook", "Instagram", "LinkedIn", "Twitter"]; // Order for displaying platform bars

  const chartData = useMemo(() => {
    const metricsToDisplay = ["Likes", "Comments", "Shares"];
    const data = [];

    metricsToDisplay.forEach((metricName) => {
      const metricEntry = { metric: metricName };

      liveChartMetrics.forEach((entry) => {
        let value = 0;
        switch (metricName) {
          case "Likes":
            value = entry.likes || 0;
            break;
          case "Comments":
            value = entry.comments || 0;
            break;
          case "Shares":
            value = entry.shares || 0;
            break;
          default:
            value = 0;
        }

        metricEntry[entry.platform] = value;
      });

      data.push(metricEntry);
    });

    return data;
  }, [liveChartMetrics]);

  const pieData = useMemo(() => {
    if (!filteredAnalysisDataForSelectedPost) return [];
    return platformOrder
      .map((platformName) => {
        const metric =
          filteredAnalysisDataForSelectedPost?.analysis?.metrics?.find(
            (m) => m.platform === platformName
          );
        return {
          name: platformName,
          value: metric?.likes || 0,
        };
      })
      .filter((data) => data.value > 0);
  }, [filteredAnalysisDataForSelectedPost, platformOrder]); // Dependency on filteredAnalysisDataForSelectedPost

  const pieChartData = useMemo(() => {
    return liveChartMetrics.map((entry) => ({
      name: entry.platform,
      value: entry[selectedMetric] || 0,
      color: entry.color || "#ccc", // fallback color
    }));
  }, [liveChartMetrics, selectedMetric]);

  const openPlatformDetailModal = (row) => {
    console.log("Modal open for:", row); // ✅ Debug log
    setCurrentPlatformData({
      platform: row.platform,
      interactions: {
        reactions: row.likes || 0,
        comments: row.comments || 0,
        shares: row.shares || 0,
        saves: 0, // Use real if available
      },
      linkClicks: 0,
      netFollows: 0,
      views: {
        total: 0,
        malePercent: 0,
        femalePercent: 0,
      },
      demographics: [],
      topCountries: [],
    });
    setShowDetailedPlatformModal(true);
  };

  const closePlatformDetailModal = useCallback(() => {
    setShowDetailedPlatformModal(false);
    setCurrentPlatformData(null);
  }, []);

  const handlepostclick = async (data) => {
    // console.log('data >>', data);
    const posterdondata = data?.postedon ? JSON.parse(data?.postedon) : [];
    const newpostdetailsarr = [];
    const fbMap = {};
    const chartMetricsArr = [];

    for (let i = 0; i < posterdondata?.length; i++) {
      const obj = posterdondata[i];
      // console.log('obj >>', obj);
      var prevpostid = obj?.postedid;
      var checkprevpostid = prevpostid.split("_");
      if (checkprevpostid?.length > 1) {
        prevpostid = obj?.postedid;
      } else {
        prevpostid = obj?.pageid + "_" + obj?.postedid;
      }
      const postId = prevpostid;
      // const accessToken = obj?.access_token;
      const accessToken = platformkeyobjRef?.current?.[obj?.platform]?.[
        obj?.pageid
      ]
        ? platformkeyobjRef.current[obj?.platform][obj?.pageid]
        : obj?.access_token;
      const platform = obj?.platform;
      const pageName = obj?.accountname || obj?.pageName || "Unknown Page";
      const platformLabel = `${platform} - ${pageName}`;

      console.log("accessToken >>", accessToken);

      let likes = 0,
        shares = 0,
        comments = 0,
        impressions = 0,
        reach = 0;

      if (platform === "Facebook") {
        try {
          const metaUrl = `https://graph.facebook.com/v19.0/${postId}?fields=shares,likes.summary(true),comments.summary(true)&access_token=${accessToken}`;
          const metaRes = await fetch(metaUrl);
          const metaData = await metaRes.json();
          if (metaData.error) {
            // Log the error
            console.error("Facebook API Error:", metaData.error);

            // Check for token expiry (code 190)
            if (metaData.error.code === 190) {
              if (
                metaData.error.error_subcode === 463 ||
                metaData.error.error_subcode === 467
              ) {
                // Expired token
                // throw new Error('Page access token has expired. Please refresh it.');
                Swal.fire({
                  text: "Page access token has expired. Please logout & login in platforms.",
                  icon: "error",
                  width: "350px",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: { popup: "small-icon-alert" },
                });
                return;
              } else {
                // Invalid token
                // throw new Error('Invalid page access token.');
                Swal.fire({
                  text: "Invalid page access token. Please logout & login in platforms.",
                  icon: "error",
                  width: "350px",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: { popup: "small-icon-alert" },
                });
                return;
              }
            }

            // Any other API error
            throw new Error(metaData.error.message);
            return;
          }

          likes = metaData?.likes?.summary?.total_count || 0;
          shares = metaData?.shares?.count || 0;
          comments = metaData?.comments?.summary?.total_count || 0;

          obj.likes_count = likes;
          obj.shares_count = shares;
          obj.comments_count = comments;
        } catch (err) {
          console.error("Facebook fetch error (likes/comments/shares):", err);
        }

        try {
          const insightsUrl = `https://graph.facebook.com/v19.0/${postId}/insights?metric=post_impressions,post_impressions_unique&access_token=${accessToken}`;
          const insightsRes = await fetch(insightsUrl);
          const insightsData = await insightsRes.json();

          if (Array.isArray(insightsData?.data)) {
            insightsData.data.forEach((metric) => {
              if (metric.name === "post_impressions") {
                impressions = metric?.values?.[0]?.value || 0;
              } else if (metric.name === "post_impressions_unique") {
                reach = metric?.values?.[0]?.value || 0;
              }
            });
          }
        } catch (err) {
          console.error("Facebook insights fetch error:", err);
        }

        fbMap[platformLabel] = {
          likes,
          shares,
          comments,
        };

        chartMetricsArr.push({
          platform: platformLabel,
          impressions,
          reach,
          likes,
          shares,
          comments,
        });

        newpostdetailsarr.push({
          platform: platformLabel,
          impressions,
          reach,
          likes,
          shares,
          comments,
        });
      }

      // for instagram
      else if (platform === "Instagram") {
        try {
          // Initialize all metrics to 0
          let likes = 0;
          let comments = 0;
          let shares = 0;
          let reach = 0;
          let saves = 0;
          let profileVisits = 0;
          let netFollows = 0;
          let plays = 0;
          let video_views = 0;
          let totalInteractions = 0;
          let accountsEngaged = 0;
          let fromProfile = 0;
          let profileActivity = 0;
          // Follower metrics are not available on this endpoint, so we've removed them.
          let followersPercent = 0;
          let nonFollowersPercent = 0;
          let interactionFollowersPercent = 0;
          let interactionNonFollowersPercent = 0;

          const mediaId = obj?.postedid;

          // Ensure mediaId exists before proceeding
          if (!mediaId) {
            console.error("Instagram API Error: mediaId is missing.");
            return;
          }

          // STEP 1: Fetch Media basic info
          const metaUrl = `https://graph.facebook.com/v22.0/${mediaId}?fields=media_type,like_count,comments_count&access_token=${accessToken}`;
          const metaRes = await fetch(metaUrl);
          const metaData = await metaRes.json();

          // Log and handle API errors with more detail
          if (metaData?.error) {
            console.error(
              "Instagram API Error (Media Info):",
              metaData.error.message,
              "Code:",
              metaData.error.code
            );
            return;
          }

          likes = metaData?.like_count || 0;
          comments = metaData?.comments_count || 0;

          // Update the object with basic info
          obj.likes_count = likes;
          obj.comments_count = comments;
          obj.shares_count = shares; // This will be updated below with a direct insights metric

          // STEP 2: Dynamically build the metrics array based on media type
          let metrics = [
            "reach",
            "saved",
            "profile_visits",
            "follows",
            "total_interactions",
            "profile_activity",
            "shares", // This is now a supported metric
            // Removed 'impressions' because it is not supported for this media type
          ];

          // Add media-type specific metrics based on the API's supported list
          switch (metaData.media_type) {
            case "VIDEO":
              metrics.push("video_views");
              break;
            case "REEL":
              metrics.push("plays");
              break;
            case "STORY":
              metrics.push("replies");
              break;
            default:
              // Handle other media types or do nothing
              break;
          }

          // STEP 3: Insights call with the dynamically created metrics
          const insightsUrl = `https://graph.facebook.com/v22.0/${mediaId}/insights?metric=${metrics.join(
            ","
          )}&access_token=${accessToken}`;
          const insRes = await fetch(insightsUrl);
          const insData = await insRes.json();

          // Log and handle insights API errors with more detail
          if (insData?.error) {
            console.error(
              "Instagram Insights API Error:",
              insData.error.message,
              "Code:",
              insData.error.code
            );
          }

          if (Array.isArray(insData?.data)) {
            insData.data.forEach((m) => {
              const value = m?.values?.[0]?.value || 0;
              switch (m.name) {
                case "reach":
                  reach = value;
                  break;
                case "saved":
                  saves = value;
                  break;
                case "video_views":
                  video_views = value;
                  break;
                case "plays":
                  plays = value;
                  break;
                case "profile_visits":
                  profileVisits = value;
                  break;
                case "follows":
                  netFollows = value;
                  break;
                case "total_interactions":
                  totalInteractions = value;
                  break;
                case "profile_activity":
                  profileActivity = value;
                  break;
                case "shares":
                  shares = value;
                  break;
                // The 'impressions' breakdown for 'from_profile' is not supported,
                // so we've removed the logic to get it.
              }
            });
          }

        
          accountsEngaged = totalInteractions;

          // STEP 4: Store in fbMap
          fbMap[platformLabel] = {
            likes,
            shares,
            comments,
            reach,
            saves,
            plays,
            video_views,
            profileVisits,
            netFollows,
            total_interactions: totalInteractions,
            accounts_engaged: accountsEngaged,
            profile_activity: profileActivity,
            from_profile: fromProfile, // This will now always be 0
            followers_percent: followersPercent,
            non_followers_percent: nonFollowersPercent,
            interaction_followers_percent: interactionFollowersPercent,
            interaction_non_followers_percent: interactionNonFollowersPercent,
            interactions: {
              reactions: likes,
              comments: comments,
              shares: shares,
              saves: saves,
            },
          };

          // STEP 5: Chart data
          chartMetricsArr.push({
            platform: platformLabel,
            reach,
            likes,
            shares,
            comments,
          });

          // STEP 6: Details data
          newpostdetailsarr.push({
            platform: platformLabel,
            reach,
            saves,
            plays,
            video_views,
            likes,
            shares,
            comments,
            profileVisits,
            netFollows,
            total_interactions: totalInteractions,
            accounts_engaged: accountsEngaged,
            profile_activity: profileActivity,
            from_profile: fromProfile, // This will now always be 0
            followers_percent: followersPercent,
            non_followers_percent: nonFollowersPercent,
            interaction_followers_percent: interactionFollowersPercent,
            interaction_non_followers_percent: interactionNonFollowersPercent,
            interactions: {
              reactions: likes,
              comments: comments,
              shares: shares,
              saves: saves,
            },
          });
        } catch (err) {
          console.error("Instagram fetch error:", err);
        }
      }
    }

    setLiveFBDataMap(fbMap);
    setLiveChartMetrics(chartMetricsArr);

    const updatedPost = {
      ...data,
      name: data?.postname,
      analysis: {
        metrics: newpostdetailsarr,
      },
    };
    console.log("updatedPost >>", updatedPost);
    setSelectedPost(updatedPost);
    setShowDetailedPlatformModal(false);
    setCurrentPlatformData(null);
    setViewMode("table");
    setAnalysisFilterRange("all");
    setAnalysisCustomDateRange({ from: "", to: "" });
  };

  useEffect(() => {
    console.log(
      "🟢 Platforms for bar chart:",
      liveChartMetrics.map((d) => d.platform)
    );
    console.log(
      "🟢 Platforms for pie chart:",
      pieChartData.map((d) => d.name)
    );
  }, [liveChartMetrics, pieChartData]);

  const fetchUsers = async () => {
    setShowLoading(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };

    try {
      const res = await axios.get(apiUrl + "getallpostedpost", headers);
      if (res.data.status === "success") {
        const prevdata = res?.data?.data;
        setallpostlist(prevdata);
        if (prevdata?.length > 0) {
          prevdata[0].analysis = mockPostsData[0].analysis; //provide mock data for table chart pei
          const columnsarr = [];
          const hidecolumns = [
            "userid",
            "updated_at",
            "created_at",
            "status",
            "id",
            "postedon",
            "notes",
            "analysis",
            "caption",
            "mediaurls",
            "posttime",
            "allmessages",
            "aihighlights",
          ];
          const hidefilters = [];
          const columns = Object.keys(prevdata[0]);

          for (let i = 0; i < columns.length; i++) {
            if (!hidecolumns.includes(columns[i])) {
              const obj = {
                field: columns[i],
                cellStyle: { color: "#000", fontWeight: 600 },
              };
              if (!hidefilters.includes(columns[i])) {
                obj.cellClass = "inventorycell";
                obj.filter = true;
                obj.filterParams = {
                  filterOptions: ["contains"],
                  maxNumConditions: 1,
                };
              }
              columnsarr.push(obj);
            }
          }

          //action
          columnsarr.push({
            field: "action",
            headerName: "Analysis",
            cellRenderer: (props) => (
              <button
                className="post-details-view-btn"
                onClick={() => {
                  handlepostclick(props.data);
                }}
              >
                <Eye size={16} />
              </button>
            ),
          });

          setColDefs(columnsarr);
          setRowData(prevdata);
        }
      } else if (res.data.message === "invalid user") {
        dispatch({ type: "userdata", payload: {} });
        navigate("/login");
      } else {
        Swal.fire({
          text: res.data.message,
          icon: "error",
          width: "350px",
          confirmButtonText: "Ok",
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: { popup: "small-icon-alert" },
        });
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setShowLoading(false);
    }
  };

  const fetchplatformdetails = async () => {
    setShowLoading(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };

    try {
      const res = await axios.get(apiUrl + "getallplatformdetails", headers);
      if (res.data.status === "success") {
        var prevfetcheddata = res?.data?.data;
        console.log("prevfetcheddata >>", res?.data?.data);
        var prevfetcheddatakeys = Object.keys(prevfetcheddata);
        var newobj = {};
        for (var i = 0; i < prevfetcheddatakeys?.length; i++) {
          var prevpages = prevfetcheddata[prevfetcheddatakeys[i]]?.pagesarr
            ? JSON.parse(prevfetcheddata[prevfetcheddatakeys[i]]?.pagesarr)
            : [];
          // console.log('prevpages >>', prevpages);
          var pageobj = {};
          for (var p = 0; p < prevpages?.length; p++) {
            pageobj[prevpages[p]["pageid"]] = prevpages[p]["access_token"];
          }
          newobj[prevfetcheddatakeys[i]] = pageobj;
        }
        console.log("newobj >>", newobj);
        setplatformkeyobj(newobj);
      } else if (res.data.message === "invalid user") {
        dispatch({ type: "userdata", payload: {} });
        navigate("/login");
      } else {
        Swal.fire({
          text: res.data.message,
          icon: "error",
          width: "350px",
          confirmButtonText: "Ok",
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: { popup: "small-icon-alert" },
        });
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setShowLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchplatformdetails();
  }, []);

  return (
    <div className="post-details-container">
      

          <div className="create-new-campaign-header">
                <div>
                  {/* <h2 className="create-new-campaign-title">Dashboard</h2> */}
                  <p className="create-new-campaign-subtitle">
                    Here’s an overview of your campaigns.
                  </p>
                </div>
             
                <button className="create-new-campaign-btn"   onClick={() => navigate("/admin/createpost")}>
                  <Plus size={18} /> Create Post
                </button>
              </div>
        {/* <button
          className="btn-create-post"
          // onClick={() => navigate('/admin/facebook-post')}
          //   onClick={() => navigate("/admin/create-new-post")}
          onClick={() => navigate("/admin/createpost")}
        >
          <PlusCircle size={18} /> Create New Post
        </button> */}
      

      {/* Date filters are removed from here for the main table */}
      {/* <div className="ag-theme-quartz post-details-grid" style={{ height: 400, width: '100%' }}>
                <AgGridReact
                    rowData={rowData}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={10}
                    rowHeight={50}
                    animateRows={true}
                />
            </div> */}

      {/* New UI */}
      {
        allpostlist?.length > 0 ?
        <div>
        <div className="container all-post-container">
          {/* <div className="create-new-campaign-header">
            <div>
              <h2 className="create-new-campaign-title">Dashboard</h2> 
              <p className="create-new-campaign-subtitle">
                Here’s an overview of your social media post.
              </p>
            </div>
           <Link to="/admin/createpost">
              <button className="create-new-campaign-btn">
                <Plus size={18} /> Create Post
              </button>
            </Link> 
          </div> */}
          <div className="row">
            {/* Card */}

            {
                allpostlist?.map((item, index) => {
                    return (
                        <PostCard key={index} data={item} onPostClick={handlepostclick} />
                    )
                })
            }
            
          </div>
        </div>
      </div> : 
      <div>
        <p>No post data</p>
      </div>
      }
      

      {selectedPost && (
        <div className="post-details-popup">
          <div className="post-details-popup-content">
            <div className="post-details-popup-header">
              <h3>Post Analysis: {selectedPost?.name}</h3>

              <button
                className="post-details-close-btn"
                onClick={() => {
                  setSelectedPost(null);
                }}
              >
                ×
              </button>
            </div>

            {/* NEW: Date range filter moved inside the analysis popup */}

            {/* Conditional rendering based on filteredAnalysisDataForSelectedPost */}
            {!filteredAnalysisDataForSelectedPost ? (
              <div
                className="no-data-message"
                style={{ textAlign: "center", padding: "20px" }}
              >
                No analysis data available for this post within the selected
                date range.
              </div>
            ) : (
              <>
                <div className="post-view-toggle">
                  <button
                    className={viewMode === "table" ? "active" : ""}
                    onClick={() => {
                      setViewMode("table");
                    }}
                  >
                    <Table size={16} /> Table View
                  </button>
                  <button
                    className={viewMode === "chart" ? "active" : ""}
                    onClick={() => setViewMode("chart")}
                  >
                    <LayoutDashboard size={16} /> Graph View
                  </button>
                  {/* <button className={viewMode === 'demographics' ? 'active' : ''} onClick={() => setViewMode('demographics')}>
                                        <BarChart size={16} /> Demographics
                                    </button> */}
                  <button
                    className={viewMode === "ai" ? "active" : ""}
                    onClick={() => setViewMode("ai")}
                  >
                    <Info size={16} /> AI Summary
                  </button>
                  <div className="post-details-date-filters-in-popup">
                    <select
                      value={analysisFilterRange}
                      onChange={(e) => setAnalysisFilterRange(e.target.value)}
                      className="post-details-select"
                    >
                      <option value="all">
                        {" "}
                        <Calendar size={16} />
                        All Time
                      </option>{" "}
                      {/* Added 'All Time' option */}
                      <option value="15">Last 15 Days</option>
                      <option value="30">Last 30 Days</option>
                      <option value="90">Last 90 Days</option>
                      <option value="365">Last 365 Days</option>
                      <option value="custom">Custom Range</option>
                    </select>

                    {analysisFilterRange === "custom" && (
                      <div className="post-details-custom-dates">
                        <input
                          type="date"
                          value={analysisCustomDateRange.from}
                          onChange={(e) =>
                            setAnalysisCustomDateRange({
                              ...analysisCustomDateRange,
                              from: e.target.value,
                            })
                          }
                        />
                        <span style={{ margin: "0 8px" }}>to</span>
                        <input
                          type="date"
                          value={analysisCustomDateRange.to}
                          onChange={(e) =>
                            setAnalysisCustomDateRange({
                              ...analysisCustomDateRange,
                              to: e.target.value,
                            })
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>

                {viewMode === "table" && (
                  <>
                    <table className="post-details-table">
                      <thead>
                        <tr>
                          <th>Platform</th>
                          <th>Impressions</th>
                          <th>Reach</th>
                          <th>Likes</th>
                          <th>Shares</th>
                          <th>Comments</th>
                          <th>Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedPost?.analysis?.metrics?.map((row, idx) => (
                          <tr key={idx}>
                            <td>{row.platform}</td>
                            <td>{row.impressions}</td>
                            <td>{row.reach}</td>
                            <td>
                              {liveFBDataMap?.[row.platform]?.likes ||
                                row.likes}
                            </td>
                            <td>
                              {liveFBDataMap?.[row.platform]?.shares ||
                                row.shares}
                            </td>
                            <td>
                              {liveFBDataMap?.[row.platform]?.comments ||
                                row.comments}
                            </td>
                            <td>
                              <button
                                className="post-details-platform-view-btn post-details-view-btn"
                                onClick={() => openPlatformDetailModal(row)} // ✅ important
                              >
                                <Eye size={16} />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}

                {viewMode === "chart" && (
                  <>
                    <div className="post-details-chart-tabs-row">
                      <div className="post-details-chart-tabs">
                        <button
                          className={chartType === "bar" ? "active" : ""}
                          onClick={() => setChartType("bar")}
                        >
                          <BarChart size={16} /> Bar
                        </button>

                        <button
                          className={chartType === "pie" ? "active" : ""}
                          onClick={() => setChartType("pie")}
                        >
                          <PieChart size={16} /> Pie
                        </button>
                      </div>

                      <select
                        className={`post-details-metric-dropdown ${
                          chartType === "pie" ? "visible" : "hidden"
                        }`}
                        value={selectedMetric}
                        onChange={(e) => setSelectedMetric(e.target.value)}
                      >
                        <option value="likes">Likes</option>
                        <option value="comments">Comments</option>
                        <option value="shares">Shares</option>
                        <option value="reach">Reach</option>
                      </select>
                    </div>

                    <div className="post-details-chart-box">
                      <ResponsiveContainer width="100%" height={300}>
                        {chartType === "bar" && (
                          <ComposedChart
                            data={chartData}
                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                            cursor="pointer"
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="metric" />
                            <YAxis />
                            <Tooltip />
                            <Legend />

                            {liveChartMetrics.map((entry, index) => (
                              <Bar
                                key={entry.platform}
                                dataKey={entry.platform}
                                fill={
                                  platformColors[entry.platform] ||
                                  platformColors.default
                                }
                                barSize={32}
                                radius={[4, 4, 0, 0]}
                              />
                            ))}
                          </ComposedChart>
                        )}

                        {chartType === "pie" && (
                          <RePieChart>
                            <Pie
                              data={pieChartData}
                              dataKey="value"
                              nameKey="name"
                              cx="50%"
                              cy="50%"
                              outerRadius={80}
                              label
                            >
                              {pieChartData.map((entry, index) => (
                                <Cell
                                  key={`cell-${index}`}
                                  fill={
                                    platformColors[entry.name] ||
                                    platformColors.default
                                  }
                                />
                              ))}
                            </Pie>

                            <select
                              className="post-details-metric-dropdown"
                              value={selectedMetric}
                              onChange={(e) =>
                                setSelectedMetric(e.target.value)
                              }
                            >
                              <option value="likes">Likes</option>
                              <option value="comments">Comments</option>
                              <option value="shares">Shares</option>
                              <option value="reach">Reach</option>
                            </select>

                            <PieChart width={400} height={300}>
                              <Pie
                                data={pieChartData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={100}
                                label
                              >
                                {pieChartData.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={
                                      platformColors[entry.name] ||
                                      platformColors.default
                                    }
                                  />
                                ))}
                              </Pie>
                              <Tooltip />
                              <Legend />
                            </PieChart>

                            <Tooltip />
                            <Legend />
                          </RePieChart>
                        )}
                      </ResponsiveContainer>
                    </div>
                  </>
                )}

                {/* {viewMode === 'demographics' && (
                                    <div className="post-details-demographics-box">
                                        <h4>Who viewed your content (Overall)</h4>
                                        <p style={{ marginBottom: 10 }}>
                                            <span style={{ backgroundColor: '#8884d8', display: 'inline-block', width: 10, height: 10, marginRight: 5, borderRadius: '50%' }}></span>
                                            Men &nbsp;
                                            <span style={{ backgroundColor: '#82ca9d', display: 'inline-block', width: 10, height: 10, marginRight: 5, borderRadius: '50%' }}></span>
                                            Women
                                        </p>
                                        <ul className="demographics-list">
                                            {(() => {
                                                const combinedDemographics = {};

                                                filteredAnalysisDataForSelectedPost?.analysis?.metrics?.forEach(metric => {
                                                    metric.demographics.forEach(demo => {
                                                        if (!combinedDemographics[demo.group]) {
                                                            combinedDemographics[demo.group] = { male: 0, female: 0, total: 0 };
                                                        }
                                                        combinedDemographics[demo.group].male += demo.male;
                                                        combinedDemographics[demo.group].female += demo.female;
                                                        combinedDemographics[demo.group].total += demo.total;
                                                    });
                                                });

                                                const sortedGroups = Object.keys(combinedDemographics).sort((a, b) => {
                                                    const getMinAge = (group) => parseInt(group.split('-')[0] || group.replace('+', ''), 10);
                                                    return getMinAge(a) - getMinAge(b);
                                                });

                                                const overallTotalViews = filteredAnalysisDataForSelectedPost?.analysis?.metrics?.reduce((sum, metric) => sum + (metric.views?.total || 0), 0);

                                                return sortedGroups.map((groupName, index) => {
                                                    const item = combinedDemographics[groupName];
                                                    const totalGroupViews = item.total;
                                                    const malePercentInGroup = totalGroupViews > 0 ? (item.male / totalGroupViews) * 100 : 0;
                                                    const femalePercentInGroup = totalGroupViews > 0 ? (item.female / totalGroupViews) * 100 : 0;
                                                    const percentOfTotalViews = overallTotalViews > 0 ? ((totalGroupViews / overallTotalViews) * 100) : 0;

                                                    return (
                                                        <li key={index} className="demographics-bar-row">
                                                            <div className="age-label">{groupName}</div>
                                                            <div className="bar-container">
                                                                <div className="bar-female" style={{ width: `${femalePercentInGroup}%`, backgroundColor: '#82ca9d' }}></div>
                                                                <div className="bar-male" style={{ width: `${malePercentInGroup}%`, backgroundColor: '#8884d8' }}></div>
                                                            </div>
                                                            <div className="percent-label">{percentOfTotalViews.toFixed(1)}%</div>
                                                        </li>
                                                    );
                                                });
                                            })()}
                                        </ul>
                                    </div>
                                )} */}
                {/* {viewMode === 'ai' && (
                                    <ChatBot data={selectedPost} />
                                )} */}
                <div
                  className=""
                  style={{ display: viewMode === "ai" ? "block" : "none" }}
                >
                  <ChatBot data={selectedPost} />
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* NEW: Detailed Platform Analysis Modal - Separate from main PostDetails popup */}

      {showDetailedPlatformModal && currentPlatformData && (
        <div className={`platform-detail-modal `}>
          {/* ✅ LinkedIn Custom UI */}
          {currentPlatformData.platform?.startsWith("LinkedIn") && (
            <div className="linkedin-detail-analysis-container">
              <div className="platform-detail-modal-header">
                <div className="linkedin-detail-analysis-title">
                  Post Analytics {currentPlatformData.platform}
                </div>
                <button
                  className="platform-detail-close-btn"
                  onClick={closePlatformDetailModal}
                >
                  <X size={20} /> Close
                </button>
              </div>
              <div className="linkedin-detail-analysis-subtitle">
                Organic discovery
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">
                  Impressions
                </span>
                <span className="linkedin-detail-analysis-value">10000</span>
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">
                  Members reached
                </span>
                <span className="linkedin-detail-analysis-value">8000</span>
              </div>

              <div className="linkedin-detail-analysis-subtitle">
                Organic page activity
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">
                  Page viewers from this post
                </span>
                <span className="linkedin-detail-analysis-value">5</span>
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">
                  Followers gained from this post
                </span>
                <span className="linkedin-detail-analysis-value">80</span>
              </div>

              <div className="linkedin-detail-analysis-subtitle">
                Organic engagement
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">
                  Engagements
                </span>
                <span className="linkedin-detail-analysis-value">780</span>
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">
                  Engagement rate
                </span>
                <span className="linkedin-detail-analysis-value">10.4%</span>
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">Clicks</span>
                <span className="linkedin-detail-analysis-value">150</span>
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">
                  Click-through rate
                </span>
                <span className="linkedin-detail-analysis-value">6.3%</span>
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">
                  Reactions
                </span>
                <span className="linkedin-detail-analysis-value">600</span>
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">Comments</span>
                <span className="linkedin-detail-analysis-value">80</span>
              </div>
              <div className="linkedin-detail-analysis-row">
                <span className="linkedin-detail-analysis-label">Reposts</span>
                <span className="linkedin-detail-analysis-value">100</span>
              </div>
            </div>
          )}

          {/* ✅ Instagram Custom UI */}
          {currentPlatformData.platform?.startsWith("Instagram") && (
            <div className="instagram-analysis-wrapper">
              <div className="platform-detail-modal-header">
                <h3 className="insta-details-tittle-analytics">
                  Post Analytics {currentPlatformData.platform || ""}
                </h3>
                <button
                  className="platform-detail-close-btn"
                  onClick={closePlatformDetailModal}
                >
                  <X size={20} /> Close
                </button>
              </div>

              {/* ===== Views Section ===== */}
              <div className="instagram-analysis-view-section">
                <h4 className="instagram-analysis-title">Views</h4>
                <div className="instagram-analysis-metric">
                  <span>Views</span>
                  <span className="instagram-analysis-value">
                    {currentPlatformData.video_views ??
                      currentPlatformData.plays ??
                      0}
                  </span>
                </div>
                <div className="instagram-analysis-metric">
                  <span>Followers %</span>
                  <span className="instagram-analysis-value">
                    {currentPlatformData.followers_percent ?? 0}%
                  </span>
                </div>
                <div className="instagram-analysis-metric">
                  <span>Non-followers %</span>
                  <span className="instagram-analysis-value">
                    {currentPlatformData.non_followers_percent ?? 0}%
                  </span>
                </div>
                <div className="instagram-analysis-metric">
                  <span>From Profile</span>
                  <span className="instagram-analysis-value">
                    {currentPlatformData.from_profile ?? 0}
                  </span>
                </div>
                <div className="instagram-analysis-divider"></div>
                <div className="instagram-analysis-metric">
                  <span>Accounts reached</span>
                  <span className="instagram-analysis-value">
                    {currentPlatformData.reach ?? 0}
                  </span>
                </div>
              </div>
              <div className="instagram-analysis-divider"></div>
              {/* ===== Interactions Section ===== */}
              <div className="instagram-analysis-intraction-section">
                <h4 className="instagram-analysis-title">Interactions</h4>
                <div className="instagram-analysis-metric">
                  <span>Interactions</span>

                  <span className="instagram-analysis-value">
                    {currentPlatformData.total_interactions ??
                      (currentPlatformData?.interactions?.reactions ?? 0) +
                        (currentPlatformData?.interactions?.comments ?? 0) +
                        (currentPlatformData?.interactions?.shares ?? 0) +
                        (currentPlatformData?.interactions?.saves ?? 0)}
                  </span>
                </div>
                <div className="instagram-analysis-metric">
                  <span>Followers %</span>
                  <span className="instagram-analysis-value">
                    {currentPlatformData.interaction_followers_percent ?? 0}%
                  </span>
                </div>
                <div className="instagram-analysis-metric">
                  <span>Non-followers %</span>
                  <span className="instagram-analysis-value">
                    {currentPlatformData.interaction_non_followers_percent ?? 0}
                    %
                  </span>
                </div>
                <div className="instagram-analysis-divider"></div>
                <div className="instagram-analysis-metric">
                  <span>Post interactions</span>
                  <span className="instagram-analysis-value">
                    {(currentPlatformData?.interactions?.reactions ?? 0) +
                      (currentPlatformData?.interactions?.comments ?? 0) +
                      (currentPlatformData?.interactions?.shares ?? 0) +
                      (currentPlatformData?.interactions?.saves ?? 0)}
                  </span>
                </div>
                <div className="instagram-analysis-sub-metrics">
                  <div>
                    <span>
                      <Heart size={16} color="#ed4956" /> Likes
                    </span>
                    <span>
                      {currentPlatformData?.interactions?.reactions ?? 0}
                    </span>
                  </div>
                  <div>
                    <span>
                      <MessageCircle size={16} color="#262626" /> Comments
                    </span>
                    <span>
                      {currentPlatformData?.interactions?.comments ?? 0}
                    </span>
                  </div>
                  <div>
                    <span>
                      <Share2 size={16} color="#0095f6" /> Shares
                    </span>
                    <span>
                      {currentPlatformData?.interactions?.shares ?? 0}
                    </span>
                  </div>
                  <div>
                    <span>
                      <Bookmark size={16} color="#262626" /> Saves
                    </span>
                    <span>{currentPlatformData?.interactions?.saves ?? 0}</span>
                  </div>
                </div>
              </div>
              <div className="instagram-analysis-divider"></div>

              {/* ===== Accounts Engaged ===== */}

              <div className="instagram-analysis-engaged-section">
                <h4 className="instagram-analysis-title">Accounts engaged</h4>
                <div className="instagram-analysis-metric">
                  <span>Total engaged</span>
                  <span className="instagram-analysis-value">
                    {currentPlatformData.accounts_engaged}
                  </span>
                </div>
              </div>

              <div className="instagram-analysis-divider"></div>

              {/* ===== Profile Section ===== */}
              <div className="instagram-analysis-profile-section">
                <h4 className="instagram-analysis-title">Profile</h4>
                <div className="instagram-analysis-sub-metrics">
                  <div>
                    <span>Profile activity</span>
                    <span>{currentPlatformData.profile_activity ?? 0}</span>
                  </div>
                  <div>
                    <span>Profile visits</span>
                    <span>{currentPlatformData.profileVisits ?? 0}</span>
                  </div>
                  <div>
                    <span>External link taps</span>
                    <span>{currentPlatformData.linkClicks ?? 0}</span>
                  </div>
                  <div>
                    <span>Business address taps</span>
                    <span>
                      {currentPlatformData.business_address_taps ?? 0}
                    </span>
                  </div>
                  <div>
                    <span>Follows</span>
                    <span>{currentPlatformData.netFollows ?? 0}</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ✅ Twitter Custom UI */}
          {currentPlatformData.platform?.startsWith("Twitter") && (
            <div class="twitter-analysis-wrapper">
              <div className="platform-detail-modal-header">
                <h3 className="insta-details-tittle-analytics">
                  Post Analytics {currentPlatformData.platform}
                </h3>
                <button
                  className="platform-detail-close-btn"
                  onClick={closePlatformDetailModal}
                >
                  <X size={20} /> Close
                </button>
              </div>

              <div class="twitter-analysis-section">
                <div class="twitter-analysis-metric">
                  <span>Impressions</span>
                  <strong>{currentPlatformData.impressions}</strong>
                </div>
                <div class="twitter-analysis-metric">
                  <span>Engagements</span>
                  <strong>{currentPlatformData.engagements}</strong>
                </div>
                <div class="twitter-analysis-metric">
                  <span>Detail Expands</span>
                  <strong>{currentPlatformData.detailExpands}</strong>
                </div>
                <div class="twitter-analysis-metric">
                  <span>Profile Visits</span>
                  <strong>{currentPlatformData.profileVisits}</strong>
                </div>
                <div class="twitter-analysis-metric">
                  <span>New Followers</span>
                  <strong>{currentPlatformData.netFollows}</strong>
                </div>
                <div class="twitter-analysis-metric">
                  <span>Retweets</span>
                  <strong>{currentPlatformData.shares}</strong>
                </div>
                <div class="twitter-analysis-metric">
                  <span>Likes</span>
                  <strong>{currentPlatformData.likes}</strong>
                </div>
                <div class="twitter-analysis-metric">
                  <span>Link Clicks</span>
                  <strong>{currentPlatformData.linkClicks}</strong>
                </div>
              </div>
            </div>
          )}

          {/* ✅ Facebook - Keep full original layout as-is */}
          {currentPlatformData.platform?.startsWith("Facebook") && (
            <div className="platform-detail-modal-content">
              <div className="platform-detail-modal-header">
                <h3>
                  Post Analytics {currentPlatformData.platform?.split(" - ")[0]}
                </h3>
                <button
                  className="platform-detail-close-btn"
                  onClick={closePlatformDetailModal}
                >
                  <X size={20} /> Close
                </button>
              </div>

              <div className="platform-detail-grid">
                {/* Views Card */}
                <div className="platform-detail-card platform-detail-card-views">
                  <h4 className="platform-detail-card-title">Views</h4>
                  <div className="platform-detail-views-content">
                    <ResponsiveContainer width="100%" height={150}>
                      <RePieChart>
                        <Pie
                          data={[
                            {
                              name: "Male",
                              value:
                                currentPlatformData.views?.malePercent ?? 0,
                            },
                            {
                              name: "Female",
                              value:
                                currentPlatformData.views?.femalePercent ?? 0,
                            },
                          ]}
                          cx="50%"
                          cy="50%"
                          innerRadius={60}
                          outerRadius={80}
                          paddingAngle={0}
                          dataKey="value"
                        >
                          <Cell key="male-cell" fill="#5A3AEE" />
                          <Cell key="female-cell" fill="#A877F7" />
                        </Pie>
                        <text
                          x="50%"
                          y="50%"
                          textAnchor="middle"
                          dominantBaseline="middle"
                          className="platform-detail-views-total-text"
                        >
                          {currentPlatformData.views?.total?.toLocaleString() ??
                            "0"}
                        </text>
                      </RePieChart>
                    </ResponsiveContainer>

                    <div className="platform-detail-views-legend">
                      <div className="platform-detail-legend-item">
                        <span style={{ backgroundColor: "#5A3AEE" }}></span>
                        {currentPlatformData.views?.malePercent ?? 0}% Male
                      </div>
                      <div className="platform-detail-legend-item">
                        <span style={{ backgroundColor: "#A877F7" }}></span>
                        {currentPlatformData.views?.femalePercent ?? 0}% Female
                      </div>
                    </div>
                  </div>
                </div>

                {/* Net Follows */}
                <div className="platform-detail-card">
                  <h4 className="platform-detail-card-title">Net Follows</h4>
                  <p className="platform-detail-metric-value">
                    {currentPlatformData.netFollows ?? 0}
                  </p>
                </div>

                {/* Link Clicks */}
                <div className="platform-detail-card">
                  <h4 className="platform-detail-card-title">Link Clicks</h4>
                  <p className="platform-detail-metric-value">
                    {currentPlatformData.linkClicks ?? 0}
                  </p>
                </div>

                {/* Interactions */}
                <div className="platform-detail-card platform-detail-card-interactions">
                  <h4 className="platform-detail-card-title">Interactions</h4>
                  <div className="platform-detail-interactions-grid">
                    <div className="platform-detail-interaction-item">
                      <ThumbsUp size={20} color="#3b5998" />
                      <span>
                        Reactions:{" "}
                        {currentPlatformData.interactions?.reactions ?? 0}
                      </span>
                    </div>
                    <div className="platform-detail-interaction-item">
                      <MessageSquare size={20} color="#4267B2" />
                      <span>
                        Comments:{" "}
                        {currentPlatformData.interactions?.comments ?? 0}
                      </span>
                    </div>
                    <div className="platform-detail-interaction-item">
                      <Share2 size={20} color="#36a420" />
                      <span>
                        Shares: {currentPlatformData.interactions?.shares ?? 0}
                      </span>
                    </div>
                    <div className="platform-detail-interaction-item">
                      <Bookmark size={20} color="#fa3e3e" />
                      <span>
                        Saves: {currentPlatformData.interactions?.saves ?? 0}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Age + Gender */}
                <div className="platform-detail-card platform-detail-card-demographics">
                  <h4 className="platform-detail-card-title">
                    Who viewed your content <small>(Age and Gender)</small>
                  </h4>
                  <div className="platform-detail-demographics-list">
                    {(currentPlatformData.demographics || []).map(
                      (demographic, index) => {
                        const totalGroupViews = demographic.total ?? 0;
                        const male = demographic.male ?? 0;
                        const female = demographic.female ?? 0;

                        const malePercentInGroup =
                          totalGroupViews > 0
                            ? (male / totalGroupViews) * 100
                            : 0;
                        const femalePercentInGroup =
                          totalGroupViews > 0
                            ? (female / totalGroupViews) * 100
                            : 0;

                        const totalPlatformViews =
                          currentPlatformData.views?.total ?? 0;
                        const percentOfTotalViews =
                          totalPlatformViews > 0
                            ? (totalGroupViews / totalPlatformViews) * 100
                            : 0;

                        return (
                          <div
                            key={index}
                            className="platform-detail-demographics-bar-row"
                          >
                            <div className="platform-detail-age-label">
                              {demographic.group ?? "N/A"}
                            </div>
                            <div className="platform-detail-bar-container">
                              <div
                                className="platform-detail-bar-female"
                                style={{ width: `${femalePercentInGroup}%` }}
                              ></div>
                              <div
                                className="platform-detail-bar-male"
                                style={{ width: `${malePercentInGroup}%` }}
                              ></div>
                            </div>
                            <div className="platform-detail-percent-label">
                              {percentOfTotalViews.toFixed(1)}%
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>

                {/* Top Countries */}
                <div className="platform-detail-card platform-detail-card-countries">
                  <h4 className="platform-detail-card-title">Top Countries</h4>
                  <ul className="platform-detail-top-countries-list">
                    {(currentPlatformData.topCountries || []).map(
                      (country, index) => (
                        <li key={index}>
                          <Globe size={14} /> {country}
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PostDetails;
